import { HTML_INJECTION_REGEXP } from "constants/consts";

export const SUMMARY_FUNCTION_DERIVATIVE = "derivative";
export const TARGET_IMMEDIATELY = "immediately";
export const TARGET_DURATION = "duration";
export const DEFAULT_DURATION = 5;
export const DEFAULT_THRESHOLD = 20;
export const ABSENT_THRESHOLD = 0;
export const MIN_MINUTES_INPUT = 1;
export const MAX_MINUTES_INPUT = 60;

export const DEFAULT_INTERVAL_OPTIONS = [
  { text: "5 minutes", value: 5 },
  { text: "10 minutes", value: 10 },
  { text: "15 minutes", value: 15 },
  { text: "20 minutes", value: 20 },
  { text: "30 minutes", value: 30 },
  { text: "45 minutes", value: 45 },
  { text: "1 hour", value: 60 },
  { text: "3 hours", value: 180 },
  { text: "6 hours", value: 360 },
  { text: "12 hours", value: 720 },
  { text: "1 day", value: 1440 },
  { text: "7 days", value: 10080 },
];

export const DEFAULT_DURATION_LIST = [5, 10, 15, 20, 30, 45, 60];

export const RUNBOOK_URL_REGEXP = /^(?:http(s)?:\/\/)\S+$/;
export const validRunbookUrlRegexp = new RegExp(RUNBOOK_URL_REGEXP, "gi");

export const ALERT_NAME_REGEXP = /^[\w.-]{1,255}$/;
export const validAlertNameRegexp = new RegExp(ALERT_NAME_REGEXP);

export const invalidDescriptionRegexp = new RegExp(HTML_INJECTION_REGEXP, "g");

export const descriptionError =
  "Description contains invalid characters. Angle brackets are not allowed.";
export const alertNameError =
  "Alert name is invalid. Only combination of letters, numbers, period, hyphen, underscore is allowed. Maximum 255 characters and can't be empty.";
export const runbookUrlError = "Runbook url is invalid. HTTP(S) is required.";

export const conditionEnum = {
  TYPE: "type",
  THRESHOLD: "threshold",
  METRIC_NAME: "metricName",
  TAGS: "tags",
  ACTIVE: "active",
  SUMMARY_FUNCTION: "summaryFunction",
  DURATION: "duration",
};

export const targetEnum = {
  IMMEDIATELY: "immediately",
  DURATION: "duration",
};

export const typeEnum = {
  ABOVE: "above",
  BELOW: "below",
  ABSENT: "absent",
};

export const alertTypeEnum = {
  HOST: "host",
  APM: "apm",
  CUSTOM: "custom",
};

export const groupByEnum = {
  ALL: "all",
  ANY: "any",
  CUSTOM: "custom",
};

export const tagTypesEnum = {
  FILTERED_BY: "filtered by",
  GROUPED_BY: "grouped by",
};
